(ns manatee.admin.pending-items.components
  "Components for the Admin. Pending Items tab."
  (:require
   [clojure.string :as s]
   [manatee.admin.components :as admin-components]
   [manatee.admin.pending-items.handlers :as handlers]
   [manatee.admin.pending-items.subs :as subs]
   [manatee.annotation.subs :as annotation]
   [manatee.components.modal.handlers :as modal-handlers]
   [manatee.components.table.formatters :as formatters]
   [manatee.user.components :as user-components]
   [re-frame.core :as rf]
   [rothko.button.component :as button]
   [rothko.collection-components.core :as collection]
   [rothko.collection-components.table.component :as table]
   [rothko.form2.component :as form]
   [rothko.form2.label.component :as label]
   [rothko.form2.select.core :as select]
   [rothko.form2.select.single-select.component :as single-select]
   [rothko.layout.component :as layout]
   [rothko.panel.component :as panel]))

(defn- pending-panel-table
  [user items to-reassign]
  [table/component
   {:appearance #{:primary}
    ::collection/items (sort-by (juxt :reported? :has-edits? :deferred? :item-group-id) items)
    ::collection/fields [{::collection/label "Reassign"
                          ::table/formatter (fn [_ {:keys [item-group-id]}]
                                              [:input
                                               {:type :checkbox
                                                :checked (contains? to-reassign item-group-id)
                                                :on-change #(rf/dispatch
                                                             [::handlers/pending-item-to-reassign-checked
                                                              item-group-id
                                                              (.. % -target -checked)])}])}
                         {::collection/label "Item"
                          ::table/formatter (formatters/item-group-id
                                             (:id user)
                                             {:go-back-only true})}
                         {::collection/label "Task"
                          ::table/formatter  (formatters/smaller-p :item-task)
                          ::table/ordered?   true}
                         {::collection/label "Deferred"
                          ::table/formatter (formatters/transform-field
                                             :deferred?
                                             (comp s/capitalize str))}
                         {::collection/label "Has edits"
                          ::table/formatter (formatters/transform-field
                                             :has-edits?
                                             (comp s/capitalize str))}
                         {::collection/label "Reported"
                          ::table/formatter (formatters/transform-field
                                             :reported?
                                             (comp s/capitalize str))}]}])

(defn- pending-panel-footer
  [active-users user to-reassign]
  (let [assignee @(rf/subscribe [::subs/assign-to])]
    (prn :user-to-assign-to user assignee)
    [:div.spacer
     [label/component {::form/label "Reassign to user:"}]
     [single-select/field
      (merge (admin-components/form-field-props (or assignee :sys) #(rf/dispatch [::handlers/assign-to %]))
             {::select/options (->> active-users
                                    (remove #(= (:id %) (:id user)))
                                    (map #(hash-map :value %
                                                    :representation (user-components/full-name %)
                                                    :tooltip (:email %)))
                                    (cons {:value :sys :representation "*System User*"}))})]
     [button/button {:appearance #{:primary}
                     :on-click #(rf/dispatch [::modal-handlers/show :confirm-reassign-pending])
                     :disabled? (or (nil? assignee) (empty? to-reassign))}
      "Reassign"]
     [admin-components/confirmation-dialog
      {:id :confirm-reassign-pending
       :class [:admin-page__confirmation-dialog]
       :ok-fn #(do (rf/dispatch [::handlers/reassign-pending-items user to-reassign assignee])
                   (rf/dispatch [::modal-handlers/hide :confirm-reassign-pending]))
       :cancel-fn #(rf/dispatch [::modal-handlers/hide :confirm-reassign-pending])}
      [:span "Are you sure you want to reassign the " (count to-reassign)
       " selected pending item" (when (second to-reassign) "s") " to "
       (if (= :sys assignee)
         "the system user"
         (str "user " (user-components/full-name assignee)))
       "?"]]]))

(defn- pending-panel-body
  [{:keys [active-users] :as _props}]
  (let [user-selected #(rf/dispatch [::handlers/fetch-pending-items %])
        {:keys [user items]} @(rf/subscribe [::subs/pending-items])
        to-reassign @(rf/subscribe [::subs/pending-items-to-reassign])]
    [:div {:key (count active-users)}
     [label/component {::form/label "Choose a user:"}]
     [single-select/field
      (merge (admin-components/form-field-props user user-selected)
             {::select/options (->> active-users
                                    (map #(hash-map :value %
                                                    :representation (user-components/full-name %)
                                                    :tooltip (:email %))))})]
     [:div.spacer
      (cond
        @(rf/subscribe [::annotation/loading?])
        "Loading..."

        (and user (empty? items))
        [label/component {::form/label (str (user-components/full-name user) " has no pending items.")}]

        user
        [:<>
         [label/component {::form/label (str (user-components/full-name user) " has the following pending items:")}]
         [pending-panel-table user items to-reassign]
         [pending-panel-footer active-users user to-reassign]])]]))

(defn pending-panel
  [props]
  [panel/panel {:appearance #{:primary}
                :class [:admin-page__panel]}
   [layout/layout {:appearance #{:column}
                   :class [:admin-page__form-layout]}
    [:h4 {:class [:admin-page__header]} "View or reassign pending items assigned to a user"]
    [pending-panel-body props]]])
